import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import DialogComponent from "../reusableComponents/Dialog";
import axios from "axios";
import "react-html5-camera-photo/build/css/index.css";
import { useHistory } from "react-router-dom";

import * as moment from "moment";
import addIcon from "../../images/add.svg";
import deleteIcon from "../../images/del.svg";
import { toast } from "react-toastify";

import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import AddItem from "./AddItem";
import UpdateItem from "./UpdateItem";
import { discountAdded } from "./itemsSlice";
import { getItems, saleItem } from "./itemsSlice";
import { removeBulkItems } from "./itemsSlice";
import { remSelectedPurchase } from "./itemsSlice";
import { unselectItems } from "./itemsSlice";
import { removeBulk, updateItems, updateItemsDisc } from "./httpCalls";
import { getVendors } from "../vendors/vendorSlice";
import ItemsRepository from "../../Repository/ItemsRepository";
import FileRepository from "../../Repository/FileRepository";
import { getAllRacks } from "../../httpcalls/racks";
import { getQty } from "../../utils/getQty";
import { RFTfeature } from "../features/RFTfeature";
import { Box, Table } from "@mui/material";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Checkbox, FormControl, Grid, InputAdornment } from "@mui/material";
import {
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { SearchInput, TopButton } from "./style";
import Loader from "../components/Loader";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { selectForPurchase } from "../purchaseOrders/purchaseSlice";
import { selectForReturn } from "../saleReturn/saleReturnSlice";
import { BoxesPacking } from "../features/BoxesPacking";
import Repo from "../../Repository/Repo";
import { Toast } from "../components/Toast";
import AddToStore from "./AddToStore";
import ShowItemsDetails from "./ShowItemsDetails";
import { itemNewDesign } from "../features/ItemNewDesign";
import SearchNew from "../components/SearchNew";
import SearchInventoryNew from "../components/SearchInventoryNew";

function Inventory() {
  let companyCode = localStorage.getItem("companyCode");
  const dispatch = useDispatch();
  const [width, setWidth] = useState(window.innerWidth);
  const vendor = useSelector((state) => state.vendor);
  const inventory = useSelector((state) => state.inventory.items);
  const selectedForPurchase = useSelector((state) => state.inventory.selected);
  const { company } = useSelector((state) => state.company);

  const loading = useSelector((state) => state.inventory.loading);

  const [transferDate, setTransferDate] = useState("");
  const inputRef = useRef();
  const history = useHistory();
  const [myshops, setmyShops] = useState([]);
  const [racks, setRacks] = useState([]);
  console.log("racks", racks);
  const [selectedShop, setSelectedShop] = useState("");
  const [addDiscount, setAddDiscount] = useState("");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [toggle, setToggle] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [state, setState] = useState({
    selectedVendor: "all",
    searchText: "",
    searchedItems: [],
    itemsFound: "",
    addDiscount: "",
    discountModal: false,
    remBulkModal: false,
    removeLoading: false,
    saleReturnModal: false,
    purchaseModal: false,
    transferModal: false,
    exportModal: false,
    addModal: false,
    editModal: false,
    storeModal: false,
    selected: [],
  });

  const updateOnlineStatus = () => {
    setIsOnline(navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    // Cleanup function to remove the event listeners when the component unmounts
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  //   useEffect(() => {
  //     // if(isOnline == true) {
  //  console.log('online')
  //     handles();

  //     if (vendor.vendors == "") {
  //       dispatch(getVendors());
  //     }
  //     if (inventory == "") {
  //       dispatch(getItems());
  //     }
  //   // }
  //   }, []);

  useEffect(() => {
    if (isOnline == true) {
      handles();

      if (vendor?.vendors?.length === 0) {
        dispatch(getVendors());
      }
      // if (inventory.length === 0) {
      // dispatch(getItems());
      // }
    }
  }, [dispatch, vendor?.vendors?.length, inventory?.length, isOnline]);

  useEffect(() => {
    dispatch(getItems());
  }, []);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  let token = localStorage.getItem("tokenType");

  const showCostPrice =
    token == "admin" ? true : company?.access?.includes("Cost Price");
  console.log("showCostPrice", showCostPrice);
  const checkIds = state.selected.reduce((acc, item) => {
    acc[item._id] = item._id;
    return acc;
  }, {});

  const handles = () => {
    getShops();
    getMyRacks();
  };
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };
  const searchHandle = async (text, vendor) => {
    console.log(text, "valll");
    let textValue = text;

    // console.log("text", textValue);
    // let res = inventory.filter((item) => {
    //   console.log('itemmmmmm', item)
    //   const name = item.name ? item.name.toString().toLowerCase() : "";
    //   const ItemId = item.itemId ? item.itemId.toString().toLowerCase() : "";
    //   // const BarcodeId = item.barCode ? item.barCode.toString().toLowerCase() : '';
    //  const codeId = item.name.toLowerCase()  ?  item.name.toLowerCase()  :  ""
    //  const batchNumberSelected = Array.isArray(item.batchNumber) && item.batchNumber.length > 0
    //  ? item.batchNumber[0].batchNumber
    //  : "";
    //   console.log("name", name);
    //   console.log("code", ItemId);
    //   console.log("batchnn", batchNumberSelected);

    //   return (
    //     name.includes(textValue.toLowerCase()) ||
    //     ItemId.includes(textValue.toLowerCase()) ||
    //     item?.barCode?.includes(textValue) ||
    //     batchNumberSelected.includes(textValue)  ||
    //     codeId?.startsWith(textValue)
    //   );
    // });

    // console.log("items", res);

    let vend = vendor == "all" ? "" : vendor;
    let { data } = await ItemsRepository.itemsModel({
      request: {
        method: "getSearchItems",
        data: {
          company_code: localStorage.getItem("companyCode"),
          search_item: text,
          vendor: vend,
        },
      },
    });
    let res = data.response.data.items;
    console.log("data", data);
    if (res.length > 0) {
      setState((prev) => ({ ...prev, searchedItems: res }));
    } else {
      setState((prev) => ({
        ...prev,
        searchedItems: res,
        itemsFound: "empty",
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value == "") {
      setState((prev) => ({
        ...prev,
        [name]: value,
        searchedItems: [],
        itemsFound: "",
      }));
    } else {
      setState((prev) => ({ ...prev, [name]: value, itemsFound: "" }));
    }
    if (name == "selectedVendor") {
      if (value != "all") {
        searchHandle(state.searchText, value);
      } else {
        setState((prev) => ({ ...prev, searchedItems: [] }));
      }
    }
  };

  async function getMyRacks() {
    let data = await getAllRacks();
    let final_racks = data.response.data.racks.map((item) => {
      return {
        ...item,
        racks: {
          ...item.racks,
          editable: false,
          isedit: item.racks.sub_rack.map((its) => {
            return false;
          }),
        },
      };
    });

    setRacks(final_racks);
  }

  const currentDate = () => {
    let today = moment().format("DD-MM-YYYY");
    return today;
  };

  function isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  const readFile = (file) => {
    console.log("A");
    let f = file;
    console.log(file);

    const reader = new FileReader();
    reader.onload = async (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      console.log("data", data);
      /* Update state */
      console.log("B");
      const arrs = ["name", "quantity", "description", "price", "costPrice"];
      let bools = true;
      for (let index = 0; index < arrs.length; index++) {
        const element = arrs[index];
        console.log("element", element);
        bools = isInArray(element, data[0]);
        console.log("bools", bools);

        if (bools == false) {
          break;
        }
      }
      console.log("C");
      if (bools == false) {
        toast.configure();
        toast.info(
          "Make sure these columns are present in your file name,quantity, description,price,costPrice"
        );

        return;
      }
      console.log("D");
      console.log("file", file);
      let resp = await FileRepository.fileModel({
        file: file,
        company_code: localStorage.getItem("companyCode"),
      });
      console.log("E");
      // refreshItemsList();
      dispatch(getItems());
    };
    reader.readAsBinaryString(f);
    console.log(f);
  };

  async function getShops() {
    // setLoading(true);
    let { data } = await Repo.shops({
      request: {
        method: "getShopsByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });

    setmyShops(data.response.data.shops);
    if (data.response.data.shops.length > 0) {
      setSelectedShop(data.response.data.shops[0].shop_code);
    }
    // setLoading(false);
  }

  const itemEdit = (item, index) => {
    console.log("item", item);
    setState((prev) => ({
      ...prev,
      editItem: item,
      editIndex: index,
      editModal: true,
    }));
  };

  function getDate(date) {
    let purchase;
    let day = date.slice(8, 10);
    let month = date.slice(5, 7);
    let year = date.slice(0, 4);

    purchase = day + "-" + month + "-" + year;
    return purchase;
  }

  const handleSelect = (item, index) => {
    let found = item._id == checkIds[item._id];
    if (found) {
      let copy = JSON.parse(JSON.stringify(state.selected));
      let idx = copy.findIndex((i) => i._id == item._id);
      copy.splice(idx, 1);
      setState((prev) => ({ ...prev, selected: copy }));
    } else {
      setState((prev) => ({ ...prev, selected: [...prev.selected, item] }));
    }
  };
  const transfertoShop = () => {
    handleModal("transferModal");
    let transfer = "";
    if (transferDate) {
      let d = moment(transferDate).format("DD-MM-YYYY");
      const [day, month, year] = d.split("-").map(Number);
      const date = new Date(Date.UTC(year, month - 1, day));
      const newUnixTimestamp = Math.floor(date.getTime() / 1000);
      transfer = newUnixTimestamp;
    } else {
      transfer = Math.floor(Date.now() / 1000);
    }

    let updatedItems = [];
    let copyItems = JSON.parse(JSON.stringify(state.selected));
    copyItems.forEach((item) => {
      let found = inventory.find((itx) => itx._id == item._id);

      let qts = found.quantity - item.quantity;
      if (!item.shop_stock) {
        item.shop_stock = [];
        item.shop_stock.push({
          shop_code: selectedShop,
          shop_quantity: parseInt(item.quantity),
        });
      } else {
        let alreadyinside = item?.shop_stock.find(
          (itx) => itx.shop_code == selectedShop
        );
        let shopindx = item.shop_stock.findIndex(
          (itx) => itx.shop_code == selectedShop
        );

        if (alreadyinside != null) {
          item.shop_stock[shopindx].shop_quantity =
            parseInt(item.shop_stock[shopindx].shop_quantity) +
            parseInt(item.quantity);
        } else {
          item.shop_stock.push({
            shop_code: selectedShop,
            shop_quantity: parseInt(item.quantity),
          });
        }
      }
      item.quantity = qts;
      item.transferDate = transfer;

      updatedItems.push(item);
    });
    dispatch(saleItem(updatedItems));
    setState((prev) => ({ ...prev, selected: [] }));
    updateItems(updatedItems, dispatch, "", "Transfer");
  };

  const addToPurchase = () => {
    dispatch(selectForPurchase(state.selected));
    history.push("/inventory/admin/purchase-order");
  };

  const addToSaleReturn = () => {
    dispatch(selectForReturn(state.selected));
    history.push("/inventory/admin/sale-returns");
  };

  const deleteBulkItems = async () => {
    setState((prev) => ({ ...prev, remBulkModal: false, removeLoading: true }));
    dispatch(removeBulkItems(state.selected));
    await removeBulk(state.selected, dispatch);
    setState((prev) => ({
      ...prev,
      selected: [],
      removeLoading: false,
    }));
  };

  const applyDiscount = () => {
    if (!addDiscount) {
      toast.configure();
      toast.info("Provid Discount Percentage");
      return;
    }
    handleModal("discountModal");
    let updatedItems = [];
    let copyItems = JSON.parse(JSON.stringify(selectedForPurchase));
    copyItems.forEach((item) => {
      item.discount = addDiscount;
      updatedItems.push(item);
    });
    dispatch(discountAdded(updatedItems));
    dispatch(remSelectedPurchase());
    dispatch(unselectItems());
    updateItemsDisc(updatedItems, dispatch, selectedForPurchase);
    setAddDiscount("");
  };
  if (localStorage.getItem("token") == null) {
    window.location.reload();
  }

  const myToggle = (newName = null) => {
    setSelectedItem(newName);
    setToggle((prev) => !prev);
  };

  const searchItems = () => {
    if (state.searchedItems.length > 0) {
      // state.newItem.imeiNumber
      return state.searchedItems;
    } else if (state.itemsFound == "empty") {
      return [];
    } else {
      return inventory;
    }
  };
  console.log("search", state.searchedItems);
  console.log("inventory", inventory);

  // const searchItemsMemoized = useCallback(() => {
  //   console.log('Recalculating searchItemsMemoized');
  //   return searchItems();
  // }, [state.searchedItems, inventory]);

  const handleTransferQty = (e, index) => {
    let { value } = e.target;
    if (value) {
      let copy = JSON.parse(JSON.stringify(state.selected));
      copy[index].quantity = value;
      setState((prev) => ({ ...prev, selected: copy }));
    } else {
      toast.configure();
      toast.info("Select Quantity");
    }
  };
  const clearSelection = () => {
    setState((prev) => ({ ...prev, selected: [] }));
  };

  const exportToggle = () => {
    setState((prev) => ({ ...prev, exportModal: true }));
  };
  const handleModal = (name, open = "") => {
    if (open == "true" && state.selected.length == 0) {
      toast.configure();
      toast.info("Select Item First");
      return;
    } else if (name == "transferModal" && !open) {
      setState((prev) => ({ ...prev, [name]: !prev[name] }));
      setTransferDate("");
    } else {
      if (name == "transferModal") {
        if (myshops.length == 0) {
          toast.configure();
          toast.info("No shops found create some shops first");
          history.push("/inventory/admin/myshops");
          return;
        } else {
          setState((prev) => ({ ...prev, [name]: !prev[name] }));
        }
      } else {
        setState((prev) => ({ ...prev, [name]: !prev[name] }));
      }
    }
  };
  const handleExport = async () => {
    handleModal("exportModal");
    let { data } = await ItemsRepository.itemsModel({
      request: {
        method: "createAllItemsExcel",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    window.open(data.response.data.success);
  };

  const handleDate = (e) => {
    const { value } = e.target;
    setTransferDate(value);
  };

  const handleAddedToStore = () => {
    handleModal("storeModal");
    setState((prev) => ({ ...prev, selected: [] }));
  };

  return (
    <div>
      <Box sx={{ mt: "50px" }}>
        <Grid container spacing={1}>
          <Grid item md={7} xs={12}>
            <Grid container spacing={1}>
              <Grid item lg={7} md={6} xs={12}>
                <SearchInventoryNew
                  searchHandle={searchHandle}
                  fullWidth
                  // size="small"
                  // label="Search item"
                  // variant="outlined"
                  // name="searchText"
                  // value={state.searchText}
                  // onChange={handleChange}
                  // onKeyDown={(e) => {
                  //   if (e.key == "Enter") {
                  //     searchHandle(state.searchText, state.selectedVendor);
                  //   }
                  // }}
                  // InputProps={{
                  //   endAdornment: (
                  //     <InputAdornment position="start">
                  //       <SearchIcon className="gray-clr" />
                  //     </InputAdornment>
                  //   ),
                  // }}
                />
              </Grid>
              <Grid item lg={5} md={6} xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel>Items Brands</InputLabel>
                  <Select
                    name="selectedVendor"
                    label="Items Brands"
                    onChange={handleChange}
                    defaultValue=""
                    sx={{ background: "#F9F9F9" }}
                  >
                    <MenuItem value="all">All</MenuItem>
                    {vendor.vendors.map((item, index) => (
                      <MenuItem key={index} value={item?.companyName}>
                        {item?.companyName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={3.5} xs={6} className="ml-n-16">
                <TopButton
                  variant="contained"
                  onClick={() => handleModal("addModal")}
                >
                  Add Item:
                  <img
                    style={{ marginLeft: "5px", height: "19px" }}
                    src={addIcon}
                    alt="add"
                  />
                </TopButton>
              </Grid>
              {companyCode !== "4890" && (
                <Grid item lg={3.5} xs={6}>
                  <TopButton
                    variant="contained"
                    sx={{ color: "red" }}
                    onClick={() => handleModal("remBulkModal", "true")}
                  >
                    Delete Item:
                    <img
                      style={{ marginLeft: "5px", height: "19px" }}
                      src={deleteIcon}
                      alt="add"
                    />
                  </TopButton>
                </Grid>
              )}

              <Grid item lg={5} xs={12}>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ background: "#f9f9f9" }}
                >
                  <InputLabel>View selected items</InputLabel>
                  <Select label="View selected items" defaultValue="">
                    <MenuItem key="clear">
                      <span
                        style={{
                          background: "#4caf51",
                          color: "white",
                          borderRadius: "5px",
                          fontSize: "13px",
                          width: "90%",
                          textAlign: "center",
                        }}
                        onClick={clearSelection}
                      >
                        <i>Clear All</i>
                      </span>
                    </MenuItem>
                    {state.selected.map((item, idx) => (
                      <MenuItem key={idx} value={item?.id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={5} xs={12} className="ml-n-16">
            <Grid container spacing={1}>
              <Grid item lg={4} xs={6}>
                <TopButton
                  variant="contained"
                  sx={{ color: "white", background: "#A1AF4E !important" }}
                  onClick={() => handleModal("discountModal", "true")}
                >
                  Discount
                </TopButton>
              </Grid>
              <Grid item lg={4} xs={6}>
                <TopButton
                  variant="contained"
                  sx={{ color: "white", background: "#AF7D4E !important" }}
                  onClick={() => handleModal("saleReturnModal", "true")}
                >
                  Sale Return
                </TopButton>
              </Grid>
              <Grid item lg={4} xs={6}>
                <TopButton
                  variant="contained"
                  sx={{ color: "white", background: "#4EAF51 !important" }}
                  onClick={() => handleModal("storeModal", "true")}
                >
                  Add to Store
                </TopButton>
                {/* <TopButton
                  variant="contained"
                  sx={{ color: "white", background: "#4EAF51 !important" }}
                  onClick={() => handleModal("purchaseModal", "true")}
                >
                  Add to Purchase
                </TopButton> */}
              </Grid>
              <Grid item lg={4} xs={6}>
                <TopButton
                  variant="contained"
                  sx={{ color: "white", background: "#4EA9AF !important" }}
                  onClick={() => handleModal("transferModal", "true")}
                >
                  Transfer Items
                </TopButton>
              </Grid>
              <Grid item lg={4} xs={6}>
                <TopButton
                  variant="contained"
                  sx={{ color: "white", background: "#4E75AF !important" }}
                  onClick={exportToggle}
                >
                  Export Items
                </TopButton>
              </Grid>
              <Grid item lg={4} xs={6}>
                <input
                  type="file"
                  onChange={(e) => {
                    readFile(e.target.files[0]);
                  }}
                  style={{ display: "none" }}
                  ref={inputRef}
                />
                <TopButton
                  sx={{ color: "white", background: "#AF4E88 !important" }}
                  variant="contained"
                  onClick={() => {
                    inputRef.current.click();
                  }}
                >
                  Import Item
                </TopButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {loading == false && inventory == "" && (
        <h2 className="regular green" style={{ textAlign: "center" }}>
          No Items
        </h2>
      )}

      {searchItems().map((item, index) => {
        let qty = parseFloat(item.quantity);
        let decimal = qty - Math.floor(qty);
        let d = moment.unix(item?.modified_at).format("DD-MM-YYYY");
        // let bgColor = d == currentDate() ? "#bef67a" : "";
        console.log("itemBot", item);
        // const costPriceBatchInside = item?.batchNumber?.map((item,index)=> {
        //   return item?.newItem?.costPrice
        // })
        // const salePriceBatchInside = item?.batchNumber?.map((item,index)=> {
        //   return item?.newItem?.price
        // })

        const costPriceBatchInside =
          item?.batchNumber?.[0]?.newItem?.costPrice ?? null;
        const salePriceBatchInside =
          item?.batchNumber?.[0]?.newItem?.price ?? null;
        return (
          <div key={index} className="itembox">
            {/* <div key={index} className="itembox" style={{ display: 'grid', gridTemplateColumns: item.imgURL !="" && item.imgURL  ?'10% 10% 45% 10% 25%' : '10% 55% 10% 25%', gridGap: '10px' }}> */}

            <div>
              <div className="item-checkbox">
                <Checkbox
                  color="primary"
                  checked={checkIds[item._id] ? true : false}
                  onChange={() => handleSelect(item, index)}
                  value="checkedA"
                />
              </div>
            </div>
            {/* {item.imgURL !=""  && <img src={item.imgURL} width="30%" height="20%"/>  } */}

            <div className="name-des" onClick={() => itemEdit(item, index)}>
              <h2 className="font-xs-12">{item.name}</h2>

              {itemNewDesign() && (
                <p className="item-font ">Color: {item?.color}</p>
              )}

              {!itemNewDesign() && (
                <p className="item-font ">
                  Code: {item.itemCode ? item.itemCode : item.itemId}
                </p>
              )}
              {width <= 820 && <p className="item-font">Price: {item.price}</p>}
              {<p className="item-font">{item.description}</p>}

              {item.modified_at && width >= 820 && (
                <p className="item-font">
                  Updated At:
                  {moment
                    .unix(item?.modified_at)
                    .format("DD-MM-YYYY  hh:mm:ss A")}
                </p>
              )}
            </div>
            <div>
              <h4 className="regular item-font" style={{ margin: "10px" }}>
                Sale Price: {item?.price || salePriceBatchInside}
              </h4>
              {(costPriceBatchInside || item?.costPrice) && showCostPrice && (
                <h4 className="regular item-font" style={{ margin: "10px" }}>
                  Cost Price: {item?.costPrice || costPriceBatchInside}
                </h4>
              )}
              {!itemNewDesign() && item?.imeiNumber && item.imeiNumber > 0 ? (
                <h4 className="regular item-font" style={{ margin: "10px" }}>
                  Steel Weight: {item.quantity * item.steelWeightKg}
                </h4>
              ) : null}
              {!itemNewDesign() &&
                item.whole_sale_price != undefined &&
                width >= 820 && (
                  <h4 className="regular item-font" style={{ margin: "10px" }}>
                    Wholesale Price: {item.whole_sale_price}
                  </h4>
                )}
              {/* {!itemNewDesign() &&
                item.totalPieces != undefined &&
                width >= 820 && (
                  <h4 className="regular item-font" style={{ margin: "10px" }}>
                    Total Boxes: {item.totalPieces}
                  </h4>
                )} */}
              {!itemNewDesign() &&
                item?.companyPrice !== undefined &&
                item?.companyPrice !== null && (
                  <h4 className="regular item-font" style={{ margin: "10px" }}>
                    Company Price: {item.companyPrice}
                  </h4>
                )}
              {!itemNewDesign() &&
                item?.expiryDate !== undefined &&
                item?.expiryDate !== null && (
                  <h4 className="regular item-font" style={{ margin: "10px" }}>
                    Expiry Date: {item?.expiryDate}
                  </h4>
                )}
              {/* {!itemNewDesign() &&
                item?.totalBoxes !== undefined &&
                item?.totalBoxes !== null && (
                  <h4 className="regular item-font" style={{ margin: "10px" }}>
                    Total Ctn/Box: {item?.totalBoxes}
                  </h4>
                )} */}
              ٖ
              {!itemNewDesign() &&
              item?.imeiNumber &&
              item.imeiNumber !== null ? (
                <h4 className="regular item-font" style={{ margin: "10px" }}>
                  Imei Number: {item.imeiNumber}
                </h4>
              ) : null}
              {!itemNewDesign() &&
              item.steelWeightKg &&
              item.quantity * item.steelWeightKg > 0 ? (
                <h4 className="regular item-font" style={{ margin: "10px" }}>
                  Steel Weight: {item.quantity * item.steelWeightKg}
                </h4>
              ) : null}
              {!itemNewDesign() && item?.shop_code && width >= 820 && (
                <h4 className="regular item-font" style={{ margin: "10px" }}>
                  Warehouse: {item?.shop_code?.shopName}
                </h4>
              )}
              {!itemNewDesign() && item?.vendor && width >= 820 && (
                <h4 className="regular item-font" style={{ margin: "10px" }}>
                  Vendor: {item.vendor}
                </h4>
              )}
              {!itemNewDesign() &&
                item?.batchNumber?.length > 0 &&
                width >= 820 && (
                  <h4 className="regular item-font" style={{ margin: "10px" }}>
                    Expiry Date:{" "}
                    {moment(item?.batchNumber[0].expiryDate).format(
                      "DD-MM-YYYY"
                    )}
                  </h4>
                )}
              {!itemNewDesign() &&
                item?.batchNumber?.length > 0 &&
                width >= 820 && (
                  <h4 className="regular item-font" style={{ margin: "10px" }}>
                    Batch Number: {item?.batchNumber[0].batchNumber}
                  </h4>
                )}
              {!itemNewDesign() &&
                racks
                  ?.find((its) => its._id == item.rack_code)
                  ?.racks?.sub_rack?.map((itsub, i) => {
                    return (
                      <h4 className="regular item-font" key={i} value={itsub}>
                        Rack: {itsub}
                      </h4>
                    );
                  })}
              {itemNewDesign() && item?.carModel && (
                <p className="item-font ">Car/Model: {item?.carModel}</p>
              )}
              {itemNewDesign() && (
                <h4 className="regular item-font" style={{ margin: "10px" }}>
                  Country: {item?.country}
                </h4>
              )}
              {itemNewDesign() && (
                <h4 className="regular item-font" style={{ margin: "10px" }}>
                  Location: {item?.location}
                </h4>
              )}
            </div>
            <div className="quantity-text">
              {item.totalBoxes !== null &&
                item.totalBoxes !== undefined &&
                item.totalBoxes !== 0 && (
                  <>
                    <h4>{"Total Ctn"}</h4>
                    <h3 className="no-margin-padding">
                      <h4
                        className="regular item-font"
                        style={{ margin: "10px" }}
                      >
                        {item.totalBoxes}
                      </h4>
                    </h3>
                  </>
                )}
              <h4>{getQty(item)?.type}</h4>
              {/* {getQty(item)?.qty && ( */}
              <h3 className="no-margin-padding">{getQty(item).qty || 0}</h3>
              {/* )} */}ٖ{" "}
              {BoxesPacking() && item?.boxes && (
                <h5 className="no-margin-padding">
                  Boxes:
                  {item.boxes % 1 === 0 ? item.boxes : item.boxes.toFixed(2)}
                </h5>
              )}
              {RFTfeature() && (
                <>
                  {item.unit == "Role" && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <h5
                          style={{ color: "#4EAF51" }}
                          className="no-margin-padding"
                        >
                          Meters :
                        </h5>
                        <h5 className="no-margin-padding">
                          {(decimal * 100).toFixed(2)}
                        </h5>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <h5
                          style={{ color: "#4EAF51" }}
                          className="no-margin-padding"
                        >
                          RFT :
                        </h5>
                        <h5 className="no-margin-padding">
                          {(decimal * 328).toFixed(2)}
                        </h5>
                      </div>
                    </>
                  )}
                </>
              )}
              <Button
                size="small"
                variant="contained"
                onClick={() => myToggle(item.name)}
                sx={{ textTransform: "none", color: "#fff" }}
              >
                Details
              </Button>
            </div>
          </div>
        );
      })}

      {inventory != "" && inventory.length > 500 && (
        <Button onClick={() => dispatch(getItems())}>LOAD MORE</Button>
      )}

      <DialogComponent
        title="Export Items"
        open={state.exportModal}
        onClose={() => handleModal("exportModal")}
        dialogContent={
          <div className="dialog-btns">
            <div className="dialog-btn-container">
              <button className="dialog-btn-primary" onClick={handleExport}>
                Export All
              </button>
            </div>
          </div>
        }
      />
      <DialogComponent
        title="Add Item"
        open={state.addModal}
        onClose={() => handleModal("addModal")}
        dialogContent={
          <AddItem
            onClose={() => handleModal("addModal")}
            items={inventory}
            myShops={myshops}
          />
        }
      />

      <DialogComponent
        title="Transfer Items"
        open={state.transferModal}
        onClose={() => handleModal("transferModal")}
        onClickCancel={() => handleModal("transferModal")}
        onClickYes={transfertoShop}
        dialogContent={
          <>
            <p>Select warehouse to whom you want to transfer items</p>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell className="font-xs-12">Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.selected.map((item, idx) => {
                  return (
                    <TableRow key={idx}>
                      <TableCell component="th" scope="row">
                        {item.name}
                      </TableCell>

                      <TableCell component="th" scope="row">
                        <input
                          type="number"
                          value={item.quantity}
                          onChange={(e) => handleTransferQty(e, idx)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>

            <Typography sx={{ textAlign: "left", mt: 2 }}>
              Select Transfer Date
            </Typography>
            <TextField
              fullWidth
              type="date"
              variant="outlined"
              sx={{ mb: 2 }}
              size="small"
              value={transferDate}
              onChange={handleDate}
            />

            <FormControl style={{ width: "100%" }}>
              <InputLabel>Shops</InputLabel>
              <Select
                value={selectedShop}
                defaultValue=""
                onChange={(e) => setSelectedShop(e.target.value)}
              >
                {myshops.map((item) => {
                  return (
                    <MenuItem key={item._id} value={item.shop_code}>
                      {item.shopName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </>
        }
        buttonAgreeTitle={"Transfer"}
        buttonDisAgreeTitle={"No"}
      />

      <DialogComponent
        title="Edit Item"
        open={state.editModal}
        onClose={() => handleModal("editModal")}
        dialogContent={
          <UpdateItem
            onClose={() => handleModal("editModal")}
            editItem={state.editItem}
            racks={racks}
            myShops={myshops}
            index={state.editIndex}
          />
        }
      />
      <DeleteDialog
        title="Delete Items"
        open={state.remBulkModal}
        onClose={() => handleModal("remBulkModal")}
        onClickYes={deleteBulkItems}
      />

      <DialogComponent
        title="Sale Return"
        open={state.saleReturnModal}
        onClose={() => handleModal("saleReturnModal")}
        onClickCancel={() => handleModal("saleReturnModal")}
        onClickYes={addToSaleReturn}
        dialogContent={
          <p style={{ textAlign: "center" }}>
            Are you sure you want to add these items to sale return?
          </p>
        }
        buttonAgreeTitle={"Yes"}
        buttonDisAgreeTitle={"No"}
      />

      {state.storeModal && (
        <AddToStore
          items={state.selected}
          onSuccess={handleAddedToStore}
          onClose={() => handleModal("storeModal")}
        />
      )}
      {/* <DialogComponent
        title="Add To Purchase"
        open={state.purchaseModal}
        onClose={() => handleModal("purchaseModal")}
        onClickCancel={() => handleModal("purchaseModal")}
        onClickYes={addToPurchase}
        dialogContent={
          <p>Are you sure to add these items to Store?</p>
        }
        buttonAgreeTitle={"Yes"}
        buttonDisAgreeTitle={"No"}
      /> */}

      <DialogComponent
        title="Discount"
        open={state.discountModal}
        onClose={() => handleModal("discountModal")}
        onClickCancel={() => handleModal("discountModal")}
        onClickYes={applyDiscount}
        dialogContent={
          <TextField
            required
            autoFocus
            name="addDiscount"
            label="Discount"
            type="number"
            style={{ width: "90%" }}
            variant="outlined"
            value={state.addDiscount}
            onChange={handleChange}
          />
        }
        buttonAgreeTitle={"Apply Discount"}
        buttonDisAgreeTitle={"Cancel"}
      />

      {toggle && <ShowItemsDetails onClose={myToggle} name={selectedItem} />}
      <Loader loading={loading || state.removeLoading} />
    </div>
  );
}
export default Inventory;
